import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
        color: "#343a40",
      }}
    >
      <h1 style={{ fontSize: "6rem", fontWeight: "bold", margin: "0" }}>404</h1>
      <h2 style={{ fontSize: "2rem", margin: "10px 0" }}>Page Not Found</h2>
      <p style={{ margin: "10px 0", fontSize: "1.2rem" }}>
        Oops! The page you are looking for does not exist.
      </p>
      <Link to="/dashboard" style={{ textDecoration: "none" }}>
        <button
          style={{
            padding: "10px 20px",
            fontSize: "1rem",
            color: "#fff",
            backgroundColor: "#007bff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Go to Dashboard
        </button>
      </Link>
    </div>
  );
};

export default NotFound;
